module.exports = __webpack_public_path__ + "img/等级快速回升-灰.6b6ad051.png";